export default __webpack_public_path__ + "static/media/pudim-de-leite.693a8290.jpg";